import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ReturnPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-brand-600 hover:text-brand-700 font-medium mb-8">
          <ArrowLeft className="w-4 h-4" /> Înapoi la magazin
        </Link>

        <h1 className="font-display text-4xl md:text-5xl text-ink-900 font-extrabold tracking-tight mb-8">
          Politica de Retur
        </h1>

        <div className="prose prose-lg max-w-none text-ink-700">
          <div className="bg-ink-50 p-6 rounded-lg border border-ink-200 mb-8">
            <h2 className="font-display text-xl font-extrabold text-ink-900 mb-4">Contact</h2>
            <p className="mb-2">
              Pentru orice tip de informație sau dacă doriți să faceți o reclamație, vă rugăm să ne contactați prin e-mail <a href="mailto:kintecom.contact@gmail.com" className="text-brand-600 hover:text-brand-700">kintecom.contact@gmail.com</a> de luni până vineri, în intervalul orar 9 – 16.
            </p>
          </div>

          <h2 className="font-display text-2xl font-extrabold text-ink-900 mt-8 mb-4">Reclamații și Returnarea Bunurilor</h2>
          <p className="mb-4">
            Cel mai important lucru pentru noi este satisfacția dumneavoastră. Prin urmare, dreptul de retur este de <strong>14 zile</strong>. În cazul în care întâmpinați dificultăți în legătură cu produsul sau cu livrarea, pur și simplu ne contactați telefonic sau la adresa de email, iar noi vom fi bucuroși să vă ajutăm să rezolvăm problema dumneavoastră.
          </p>
          <p className="mb-4">
            <strong>Important!</strong> Dacă suspectați că bunurile au suferit deteriorări în timpul transportului, vă rugăm să ne contactați în termen de <strong>48 de ore</strong> de la livrarea acestora, la adresa de e-mail <a href="mailto:kintecom.contact@gmail.com" className="text-brand-600 hover:text-brand-700">kintecom.contact@gmail.com</a> atașând poze atât cu coletul cât și with produsul deteriorat.
          </p>

          <h2 className="font-display text-2xl font-extrabold text-ink-900 mt-8 mb-4">Procedura în Cazul Returnării Bunurilor</h2>
          <p className="mb-4">
            Comanda nu a îndeplinit așteptările? Nu va faceti griji, bunurile ni le puteți returna în termen de <strong>14 zile</strong> de data primirii. Este destul să le trimiteți înapoi în ambalajul original intact și nedeteriorat, împreună with un biletel cu urmatoarele detalii în el:
          </p>
          <ul className="list-disc pl-5 mb-4 space-y-2">
            <li>Nume complet</li>
            <li>Numar de telefon</li>
            <li>IBAN</li>
            <li>Nume titular de cont</li>
            <li>Numar de tracking</li>
          </ul>
          <p className="mb-4">
            Suma plătită va fi restituită în contul dumneavoastră bancar.
          </p>
          <p className="mb-4">
            Suma echivalentă plății produselor, va fi restituită în contul specificat de dvs. în termen de maxim <strong>14 zile lucrătoare</strong> from momentul în care noi am intrat în posesia informațiilor de retur sau a bunurilor.
          </p>
          <p className="mb-4">
            Vă rugăm să trimiteți bunurile dumneavoastră complet împachetate în ambalajul original, pentru a preveni deteriorarea, la următoarea adresă with ramburs 0:
          </p>
          <div className="bg-brand-50 p-6 rounded-lg border border-brand-100 mb-4">
            <p className="mb-2"><strong>NUME CONTACT:</strong> KINT ECOM S.R.L</p>
            <p className="mb-2"><strong>Adresă:</strong> Strada Anghel I. Saligny 40, Oradea, cod postal 417498</p>
            <p className="mb-2"><strong>Locație:</strong> CT PARK Cargo Terminal (Helpship)</p>
            <p><strong>Ramburs 0</strong>, livrare la adresa.</p>
          </div>

          <h2 className="font-display text-2xl font-extrabold text-ink-900 mt-8 mb-4">Procedura de Depunere a Cererii pentru Retur</h2>
          <p className="mb-4">
            Există o problemă with comanda dumneavoastră? Nu este nicio problema, procedura de reclamație nu este complicată sau de lungă durată. Este suficient să ne trimiteți imediat un e-mail la <a href="mailto:kintecom.contact@gmail.com" className="text-brand-600 hover:text-brand-700">kintecom.contact@gmail.com</a> with urmatoarele date:
          </p>
          <ul className="list-disc pl-5 mb-4 space-y-2">
            <li>Nume complet</li>
            <li>Numar de telefon</li>
            <li>IBAN</li>
            <li>Nume titular de cont</li>
            <li>Numar de tracking</li>
          </ul>

          <div className="mt-12 p-6 bg-ink-50 rounded-lg border border-ink-200">
            <h2 className="font-display text-xl font-extrabold text-ink-900 mb-4">Informații de Contact</h2>
            <p className="mb-2">
              <strong>KINT ECOM S.R.L</strong>
            </p>
            <p className="mb-2">
              Email: <a href="mailto:kintecom.contact@gmail.com" className="text-brand-600 hover:text-brand-700">kintecom.contact@gmail.com</a>
            </p>
            <p className="mb-2">
              Program: Luni - Vineri, 9:00 - 16:00
            </p>
            <p>
              Site: <a href="https://kintstore.ro" className="text-brand-600 hover:text-brand-700">https://kintstore.ro</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;